
class TextInput {

    constructor($compile) {

        this.$compile = $compile;

        return {
            restrict: 'E',
            templateUrl: 'forms/text-input.html',
            compile: function (Elem, Attrs) {
                var keysToCopy = [
                  'ngModel',
                  'ng-trim',
                  'type',
                  'placeholder',
                  'name',
                  'label',
                  'pattern',
                  'required',
                  'minlength',
                  'maxlength',
                  'min',
                  'max',
                  'readonly',
                  'string-to-number',
                  'step',
                  'disabled'
                ];
                var $label = Elem.find('label');

                // copy attrs to the input
                Object.keys(Attrs).forEach(
                    function (key) {
                      if (key.indexOf('ng') === 0 || keysToCopy.indexOf(key) > -1) {
                        
                        Elem.find('input').attr(_.kebabCase(key), Attrs[key] || 1);
                      }
                    }
                );

                //add label and id
                if (Attrs['label']) $label.text(Attrs['label']);
                if (Attrs['name']) $label.attr('for', Attrs['name']);

            }
        };

    }

}


angular.module('cpm')
    .directive('textInput', () => {
        'use strict';
        return new TextInput();
    });
